
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { RoleLevel } from "../../../../domain/entities/Role";
import { useAuth } from "../../../hooks/useAuth";


export const ProtectedRoute = ({ children, level = RoleLevel.Signatory }) => {
  const { user } = useAuth();
  const loginStatus = useSelector((state) => state.session.loginStatus);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const email = searchParams.get("email");
  const campaignId = searchParams.get("cid");
  const reqId = searchParams.get("reqid");
  const shortId = searchParams.get("doc");

  const redirectURL = `${location.pathname}?${searchParams}`;
  const existingShortId = sessionStorage.getItem("shortId");

  // Check if the shortId is different before updating
  if (shortId && shortId !== existingShortId) {
    sessionStorage.setItem("shortId", shortId);
  }
  sessionStorage.setItem("redirectURL", redirectURL);

  // Immediately redirect to login if not authenticated, even if status is loading
  if (!user || level > user?.role?.level) {
    if (email && campaignId && reqId) {
      return <Navigate to="/sign" />;
    } else if (shortId && shortId.startsWith("s")) {
      return <Navigate to={`/loginExternal?doc=${shortId}`} />;
    } else if (shortId && shortId.startsWith("i")) {
      return <Navigate to="/login" />;
    } else {
      return <Navigate to="/login" />;
    }
  }

  // Optionally, you can show a spinner if you want to block rendering while loading
  // if (loginStatus === StateStatus.INIT || loginStatus === StateStatus.LOADING) {
  //   return <div>Loading...</div>;
  // }

  return children;
};
